import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-svc-order-customer-owned-tabs',
  templateUrl: './edit-svc-order-customer-owned-tabs.component.html',
  styleUrls: ['./edit-svc-order-customer-owned-tabs.component.scss']
})
export class EditSvcOrderCustomerOwnedTabsComponent implements OnInit {

  @Input() soHeadId: number | string;

  baseRoute: string;

  constructor() { }

  ngOnInit(): void {
 
    this.baseRoute = `/sales/service-orders/customer-owned/${this.soHeadId}`;

  }

}
